import { render, staticRenderFns } from "./WidgetsDropdown.vue?vue&type=template&id=8814f0ac&scoped=true"
import script from "./WidgetsDropdown.vue?vue&type=script&lang=js"
export * from "./WidgetsDropdown.vue?vue&type=script&lang=js"
import style0 from "./WidgetsDropdown.vue?vue&type=style&index=0&id=8814f0ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8814f0ac",
  null
  
)

export default component.exports